module.exports = __webpack_public_path__ + "static/media/scroll.adadc0b2.svg";